import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimgs from "../../../assets/adobeleftimg.png";
import rightimgs from "../../../assets/adoberightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";
 const foundationModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "20",
      description:
        "UI/UX Design Basic Adobe XD- Students will learn the fundamentals of UI/UX design. They will also learn to use assets and components to create animations in Adobe XD.",
    },
    {
      title: "Module 2",
      activities: "6",
      classes: "11",
      description: " Advanced Adobe XD-Students will learn to design websites, mobile apps, logos, and flyers using Adobe XD, building strong practical UI/UX skills.",
    },
  ];

  const benefitsData = [
      {
        title: "Whole Brain Development",
        description: "Activates both brain hemispheres for mental growth.",
        icon: "Polymath-images/BenefitsDataImg1.png"
      },
      {
        title: "Enhance Visual & Auditory Skills",
        description: "Sharpens listening and strengthens visual memory.",
        icon: "Polymath-images/BenefitsDataImg2.png",
      },
      {
        title: "Enhance Visual & Auditory Skills",
        description: "Improves pattern recognition and logical reasoning.",
        icon: "Polymath-images/BenefitsDataImg3.png",
      },
      {
        title: "Proficiency In Math",
        description: "Builds strong mental arithmetic and number fluency.",
        icon: "Polymath-images/BenefitsDataImg4.png",
      },
      {
        title: "Develops Speed & Accuracy",
        description: "Trains quick thinking while minimizing mistakes.",
        icon: "Polymath-images/BenefitsDataImg5.png",
      },
      {
        title: "Supports Dyslexia & Dyscalculia",
        description:
          "Inclusive, structured techniques that aid special learners.",
        icon: "Polymath-images/BenefitsDataImg6.png",
      },
      {
        title: "Personality Development",
        description: "Improves focus, discipline, and personal growth.",
        icon: "Polymath-images/BenefitsDataImg7.png",
      },
      {
        title: "Sharpens Cognitive Skills",
        description: "Enhances focus, attention span, and brain agility.",
        icon: "Polymath-images/BenefitsDataImg8.png",
      },
      {
        title: "Improves Observation",
        description: "Boosts memory retention and sharpens observation.",
        icon: "Polymath-images/BenefitsDataImg9.png",
      },
    ];
    const activitiesData = [
        {
          title: "UI/UX Fundamentals",
          image: "Polymath-images/graphic-Ui-img.png",
        },
        {
          title: "Animations",
          image: "Polymath-images/graphic-animation-img.png",
        },
        {
          title: "Shapes",
          image: "Polymath-images/graphic-shapes-img.png",
        },
        {
          title: "Logo Designing",
          image: "Polymath-images/graphic-logo-img.png",
        },
        {
          title: "Business Card",
          image: "Polymath-images/graphic-businessCard-img.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "https://www.youtube.com/embed/p4pilMiPITE",
  };
const AdobeXD = () => {
  const adobepage = heroContent.Adobesection;
  return (
    <>
       {/* <GuestNav/> */}
      <HeadSection
      leftImg={"Polymath-images/adobeleftimg.png"}
      rightImg={"Polymath-images/adoberightimg.png"}
      titlePart1="Adobe XD"
      titlePart2="Course"
      description="Polymath-Kids offers an exciting Adobe XD course for kids in Grade 4 and above, teaching them to create stories, posters, slides, animations, and more. Students will learn UI/UX and graphic design fundamentals while developing creativity, problem-solving, and branding skills. The course helps kids build professional-level designs and real-world skills."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={"Polymath-images/pencil.png"}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={foundationModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Adobe XD"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default AdobeXD